import { takeEvery } from 'redux-saga/effects';

export function savedTakeEvery(name: string | string[], worker: (action: unknown) => unknown) {
  function* savedFunc(props: unknown) {
    try {
      yield worker(props);
    } catch (err) {
      console.error(name, err);
    }
  }

  return takeEvery(name, savedFunc);
}
